import React, { useState } from "react";
import ChartVendasPeriodo from "../../../components/vendas/periodo";
import functions from "../../../util/functions";
import FilterModal from "../../../components/filter/Modal";
import HeaderReport from "../../../components/header/report";
import HeaderListFilter from "../../../components/header/report-filter";

function DashBoardVendas() {
	const [isFilterOpen, setIsFilterOpen] = useState(false);
	const [anoSelecionado, setAnoSelecionado] = useState(new Date().getFullYear());
	const [anoAtivo, setAnoAtivo] = useState(new Date().getFullYear());

	const valor = functions.primerioUltimoDiaDoAno(anoAtivo);
	const dtini = valor.primeiroDiaDoAno;
	const dtfim = valor.ultimoDiaDoAno;

	const ListarVendas = () => {
		setIsFilterOpen(false);
		setAnoAtivo(anoSelecionado);
	};

	function openFilter() {
		setIsFilterOpen(!isFilterOpen);
	}

	function closeFilter() {
		setIsFilterOpen(false);
		// Reseta para o valor que está de fato ativo
		setAnoSelecionado(anoAtivo);
	}

	if (!dtini || !dtfim) return null;

	return (
		<div className="container mt-page">
			<FilterModal
				title="Dashboard de Faturamento Anual"
				isOpen={isFilterOpen}
				onRequestClose={closeFilter}
				filterName={false}
				filterLate={false}
				onlyYear={true}
				anoSelecionado={anoSelecionado}
				setAnoSelecionado={setAnoSelecionado}
				handleList={ListarVendas}
			/>

			{/* HEADER PADRONIZADO */}
			<header className="flex flex-col bg-white p-2 rounded-sm box-shadow-md mb-6">
				<div className="grid grid-cols-2">
					<div className="col-span-1">
						<HeaderReport title="Resumo Anual" subTitle="Faturamento por Período" />
					</div>
					<div className="col-span-1 flex justify-end mb-2">
						<div className="flex flex-col gap-1">
							<HeaderListFilter
								filterData={{
									periodo: {
										label: "Período",
										value: `${functions.dateByString(dtini)} à ${functions.dateByString(dtfim)}`,
									},
								}}
							/>
						</div>
					</div>
				</div>

				<div className="col-span-1 flex justify-end items-end mt-2">
					<div className="flex gap-2 h-8">
						<button className="btn btn-sm btn-primary w-32" onClick={openFilter}>
							Filtrar
						</button>
					</div>
				</div>
				<div className="border-bottom mt-3"></div>
			</header>

			<ChartVendasPeriodo dtini={dtini} dtfim={dtfim} />
		</div>
	);
}

export default DashBoardVendas;
